import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Message from '../message/Message';
import {MESSAGE_ALERT, MESSAGE_ERROR, MESSAGE_INFO, MESSAGE_SUCCESS} from '../../../constants';

export default function DialogMessage(props) {
    const {
        type = MESSAGE_INFO,
        message = 'Nenhuma mensagem informada.',
        open,
        onClose,
        callback = () => {},
        actionButtons,
        closable = true
    } = props;

    let title;

    switch (type) {
        case MESSAGE_ERROR:
            title = 'Erro';
            break;
        case MESSAGE_ALERT:
            title = 'Aviso';
            break;
        case MESSAGE_SUCCESS:
            title = 'Sucesso';
            break;
        default:
            title = 'Informação';
            break;
    }

    function handleClose() {
        if (closable) {
            onClose();

            callback();
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown={!closable}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Message type={type}>{message}</Message>
            </DialogContent>
            <DialogActions>
                {actionButtons || <Button onClick={handleClose} color='primary' autoFocus>Fechar</Button>}
            </DialogActions>
        </Dialog>
    );
}

DialogMessage.propTypes = {
    type: PropTypes.string,
    message: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    callback: PropTypes.func,
    actionButtons: PropTypes.element,
    closable: PropTypes.bool
};